// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const hk = {
	navbar: {
		cxq:'創新區',
		st:'期待',
		home:'首頁',
		pool: '礦池',
		blockinfo: '區塊信息',
		paymenthistory: '歷史支付',
		calc: '收益計算',
		autominer: '快捷挖礦',
		mineraddress: '匿名挖礦',
		error: '錯誤',
		ica: '請輸入正確的錢包地址',
		inhint: '請輸入門羅錢包地址',
		inhinttitle: '提示',
		iem: '門羅幣錢包地址格式不正確',
		confirm: '確認',
		cancel: '取消',
		quertButton: '查看',
		chat:"聊天室",
		login:"登錄"
	},
	footer: {
		product: '產品',
		product_item1: 'Star Map礦池',
		product_item2: '收益計算器',
		help: '幫助',
		help_item1: '如何使用xmrig-proxy',
		help_item2: '如何指定挖礦算法',
		help_item3: '使用xmrig-proxy',
		help_item4: '更多教程',
		about: '關於',
		about_item1: '關於我們',
		about_item2: '隱私政策',
		about_item3: '服務協議',
		about_item4: '免責聲明',
		// qgroup: '官方QQ群：',
		// qgroup_item1: '一群：',
		// qgroup_item2: '二群：',
		// qgroup_item3: '三群：',
		// qgroup_item4: '四群：',
		// qgroup_item5: '五群：',
		// full: '(满)',
		links: '友情鏈接：'
	},
	index: {
		pool_title: '星圖，不一樣的挖礦體驗',
		pool_desc: '一站式服務，讓一切變得簡單',
		netdiff: '當前全網難度',
		algo: '幣種算法',
		coinstatus: '幣種狀態',
		fee: '費率',
		paymenttime: '付款時間',
		payThreshold: '起付額',
		payfre: '2 小時',
		cnaddress: '挖礦地址',
		foreignaddress: '全球節點',
		tlsaddrss: '加密挖礦地址',
		coinname: '幣種',
		syl: '收益率',
		syl_desc: '該百分比為收益率，是當前幣種算力和門羅算力的換算比率',
		price: '幣價',
		award: '獎勵',
		effort: '工作量',
		poolHash: '礦池算力',
		netHash: '全網算力',
		minercount: '活躍礦工',
		help: '幫助',
		chartspriceunit: '價格￥',
		chartshashunit: '算力',
		chartstitle: '歷史算力&價格',
		coinstat: '正常',
		coinstat2: '异常',
		coinstatus: '狀態正常',
		copysuccess: '複製成功',
		copysuccess_msg: '請粘貼到配置文件使用',
		tiptitle: '提示',
		helpdoc: '幫助文檔',
		paymenttime2:"12:00-16:00",
		payType:"ETH",
		payfre2: '12:00-16:00',
		support:"提現方式",
		netdiff:"全網難度",
		cpu:"CPU機槍區",
		gpu:"GPU創新區"
	},
	block: {
		title: '區塊信息',
		selectcoin: '選擇查看幣種:',
		table_id: '序號',
		table_ts: '時間',
		table_effort: '幸運度',
		table_rawaward: '原始獎勵',
		table_payment: '支付(XMR)',
		table_blockheight: '區塊高度',
		mins: '分鐘',
		soon: '即將完成',
		delay: '延遲',
		nullify: '無效',
		secago: '秒前',
		minago: '分鐘前',
		hourago: '小時前',
		dayago: '天前',
		monago: '月前',
	},
	calc: {
		title: "門羅幣 Monero (XMR)挖礦收益計算器",
		kw: '礦機功率',
		df: '電價(度)',
		yjcb: '硬件成本',
		kccs: '礦池抽水',
		dqbj: '當前幣價',
		kjsl: '礦機算力',
		input_kw: '請輸入功率',
		input_df: '請輸入電價',
		input_cb: '請輸入成本',
		input_csbl: '請輸入抽水比例',
		input_dqbj: '當前幣價',
		input_sl: '請輸入算力',
		buttontitle: '計算收益',
		wfhb: '無法回本',
		hbsj: '回本時間',
		nethash: '全網算力',
		nethiff: '挖礦難度',
		gjbj: '關機幣價',
		mrjsy: '每日淨收益',
		mzjsy: '每週淨收益',
		myjsy: '每月淨收益',
		mnjsy: '每年淨收益',
		mrcz: '每日產值',
		mryd: '每日用电',
		mrdf: '每日用電',
		mzcz: '每週產值',
		mzyd: '每周用電',
		mzdf: '每週電費',
		mycz: '每月產值',
		myyd: '每月用電',
		mydf: '每月電費',
		mncz: '每年產值',
		mnyd: '每年用電',
		mndf: '每年電費',
		r: '日',
		z: '週',
		y: '月',
		n: '年',
	},
	autominer: {
		title: 'XMRIG挖礦工具自動生成',
		title_desc: '請在下方選擇合適的系統版本配置您的礦工，默認已打開您適合的版本（默認僅供參考）',
		win: 'Windows系統',
		linux: 'Linux系统',
		mac: 'Mac系统',
		wallet_address: '錢包地址',
		minername: '礦工名稱',
		wallet_input: '請輸入錢包地址',
		minername_input: '請輸入礦工名',
		ljsc: '立即生成',
		dqsb: '當前設備信息',
		dqllq: '當前瀏覽器',
		dqxt: '當前操作系統',
		jianyi: '建議使用版本',
		input_add: '請輸入門羅錢包地址',
		input_cadd: '請輸入正確的門羅地址',
		err: '錯誤',
		errmsg: '錢包地址錯誤',
		errmsg2: '未知錯誤，未能配置成功',
		warn: '警告',
		warnmsg: '尚未選擇系統分類，無法生成',
		panel_win: '當前設備適用於window版本，已為您打開面板',
		panel_linux: '當前設備適用於Linux版本，已為您打開面板',
		panel_mac: '當前設備適用於Mac版本，已為您打開面板',
		panel_mobile: '當前設備為移動端設備，請使用PC端配置生成',
		panel_ubknown: '當前未找到您設備匹配的版本，請自行選擇版本或體驗Web挖礦',
		
		
	},
	anonminer: {
		online:'在線',
		offline:'離線',
		offline_table:'暫無數據',
		wallet_address: '錢包地址:',
		input_tip: '請輸入錢包地址',
		input_over: '查看',
		panel_title_1: '我的面板',
		panel_title_2: '我的礦機',
		panel_title_3: '支付歷史',
		panel_title_4: '機槍幣區塊支付歷史',
		panel_title_5: '我的設置',
		title_hash: '算力',
		title_miner: '礦工',
		title_earnings: '收益',
		realhahs: '實時算力',
		realhahs_desc: '轉換為門羅算法後的算力',
		avghash24: '24小時平均',
		avghash24_desc: '24小時內平均算力',
		avghash4: '4小時平均',
		avghash4_desc: '4小時內平均算力',
		due: '待支付',
		paid: '已支付',
		chartstip: '有疑問點我',
		mineremputtip: '暫無礦機',
		id: '序號',
		minername: '礦機名',
		lts: '最後提交時間',
		payhash: 'pay算力',
		rawhash: 'raw算力',
		validshares: '有效份額',
		invalidshares: '無效份額',
		totalhash: '總提交哈希',
		input_search_miner: '輸入礦機名搜索',
		clickmore: '點我查看詳細算力',
		paymentdate: '支付日期',
		paymentvalue: '支付數額(XMR)',
		blockpaymentdate: '區塊支付時間',
		blockfounddate: '區塊發現時間',
		blockpercent: '区块份额(%)',
		blockname: '區塊份額',
		clickcopy: '點擊複製完整Hash',
		prepage: '上一頁',
		nextpage: '下一頁',
		minercount: '礦工數',
		totalshares: '總提交份額',
		activeminer: '當前在線礦工數',
		minerunit: '個礦工',
		gxxe: '更新限額',
		reset: '重置',
		setaddress: '地址管理',
		addressempty: '暫時還沒有存到錢包地址',
		cz: '操作',
		del: '刪除',
		yjjb: '一鍵腳本',
		winjb: 'Windows一鍵腳本',
		linuxjb: 'Linux一鍵腳本',
		copyjb: '點我複制',
		paychartstitle: 'PAY歷史算力',
		rawchartstitle: 'RAW歷史算力',
		paychartsunit: 'pay算力',
		rawchartsunit: 'raw算力',
		linkwalleterr: '鏈接中的錢包地址錯誤',
		copysuccess: '複製成功',
		copyerror: '該瀏覽器不支持自動複製',
		yqtx: '友情提醒：',
		tomoreminer: '您礦機數量過多，這將導致加載數據過慢，請耐心等待！',
		warntip: '警告',
		warntip_desc: '尚未輸入錢包地址，歷史算力無法顯示',
		sec: '秒',
		mins: '秒',
		hour: '小時',
		zdxe: '最低限額為0.003XMR',
		success: '成功',
		updatesuccess: '更新限額成功',
		unknownerror: '未知原因',
		unknownerror_desc: '更新限額失敗',
		updatewarn: '24小時內僅能更新一次',
		updatewarn_desc: '剩餘時間：',
		echartsquestiontip: '表數據為近幾天內每分鐘數據，如波動較大屬正常現象',
		echartsquestiontiptitle: '圖表波動解釋',
		confirmbutton: '确定',
		msgtokf: '如有其他問題請諮詢客服',
		valid: '有效:',
		invalid: ',無效:',
		lts2: '最後提交時間：',
		secago: '秒前',
		minago: '分鐘前',
		hourago: '小時前',
		dayago: '天前',
		monago: '月前',
		onesecago: '1秒前',
		wallet_emptytip: '請輸入錢包地址進行查詢',
		shell_install:'安装',
		shell_uninstall:'卸載',
		txfee:"tx fee (門羅網絡轉賬費) ：+0.0001XMR"
	},
	paymenthistory: {
		title: '支付歷史',
		pay_ts: '支付時間',
		pay_payees: '支付人數',
		pay_value: '金額(XMR)',
		pay_fee: '網絡轉賬費 (XMR)',
	},
	navbar2: {
			login: "登入",
			logout: "登出",
			usercenter: "個人中心",
			loginfail: "賬戶或密碼不正確",
		},
		sidebar: {
			selectcoin: "硬幣選擇",
			usersetting: "用戶設置",
			course: "教程",
			discord1: "創新區交流",
			discord2: "Star Map 國際社區",
			course2:"提款教程",
			invite:"邀請推廣",
			inmail:"站內通知",
			yubibao:"幣生息",
			jinrong:"金融",
			baoxian:"保險",
			wange:"網格交易",
			jiedai:"借貸",
			bilicai:"雙幣理財",
			wallet:"錢包"
		},
		labseth: {
			myaccount: "我的子賬戶",
			addaccount: "添加子賬戶",
			accountName: "賬戶名",
			remark: "備註",
			confirm: "確認",
			cancel: "取消",
			changeaccount: "切換子賬戶",
			accountid: "子賬戶UID",
			accountName2: "子賬戶名",
			option: "操作",
			select: "選擇",
			realearn:"實時收益",
	        tixian:"提現",
	        all:"全部",
	        codeerr1:"驗證碼錯誤",
	        addfail:"添加失敗",
			tobesubbalance: "待提現收益",
			nowsubbalance: "提現",
			online: "在線",
			realtimehash: "實時算力",
			empty: "暫無礦機",
			stale: "延時份額",
			minedisc: "挖礦收益說明",
			earnmodel: "收益模式",
			fee: "費率",
			intoaccount: "支付時間",
			intoaccountdisc: "當日提現,次日到賬",
			support: "支付方式",
			bindgoogle: "綁定谷歌驗證器",
			googledisc: "谷歌驗證器是一款動態口令工具,工作原理類似短信動態驗證,綁定後動態密鑰每30秒變動一次,可用於登陸.提現,修改安全設置等安全驗證。",
			step1: "步驟 1:下載谷歌驗證器APP",
			step1disc: "iOS用戶登錄App Store搜索“Authenticator”下載，安卓用戶登錄應用商店或者使用手機瀏覽器搜索“谷歌驗證器”下載。",
			step2: "步驟 2:在谷歌驗證器中添加密鑰並備份",
			step2disc: "打開谷歌驗證器，掃描下方二維碼或手動輸入下方密鑰添加驗證令牌。",
			googeldisc2: "密鑰用於修改密碼或賬號遺失找回谷歌驗證器,綁定前請務必將密鑰備份保存並防止洩露!",
			step3: "步驟 3:驗證谷歌驗證器中的6位驗證碼",
			googelcode: "谷歌驗證碼",
			googlecodetip: "請輸入谷歌驗證器中的驗證碼",
			googelcodeconfirm: "立 即 驗 證",
			addpaymentaccount: "添加付款賬戶",
			paymentaccounttip: "您尚未綁定谷歌驗證，將無法提現",
			clickmetobind: "點我綁定",
			biantip: "僅支持Binance Smart Chain(BEP20/BSC)網絡",
			usdttip: "僅支持Tron(TRC20)網絡",
			alipaytip: "請牢記該密鑰，這將關係到提現問題（請使用字母+數字定義密鑰）",
			addtype: "添加類型",
			selectaddtype: "請選擇添加類型",
			key8: "8位密鑰",
			accountaddress: "賬戶地址",
			alias:"別名",
			accountalias:"賬戶别名",
			nowadd:"立即添加",
			paymentoption:"提現操作",
			addpaymentorderaccount:"添加提現賬戶",
			paymenttipwithgoogle:"您尚未綁定谷歌驗證，無法提現，請在綁定後進行提現操作",
			usdtsdisc1:"USDT僅支持使用TRX網絡【Tron(TRC20)】進行支付",
			usdtsdisc2:"最低提現額: 20 USDT",
			ethdisc1:"ETH僅支持BSC網絡【Binance Smart Chain(BEP20)】進行支付",
			ethdisc2:"到賬金額將扣除網絡費用後支付",
			ethdisc3:"最低提現:0.01 ETH",
			ethdisc4:"最低提现:0.5 ETC",
			selectkey:"選擇您提現使用的密鑰,不綁定電子郵件提現將無法到賬",
			alipaydisc:"最低提現: 100 CNY",
			paymenttype:"提現類型",
			selectpaymenttype:"請選擇提現類型",
			usdtpayment:"USDT 網絡轉賬費:1 USDT",
			ethpayment:"ETH(BSC) 網絡轉賬費:0.000070 ETH",
			alipaypayment:"Alipay 手續費:1%",
			ketishuliang:"可提數額",
			payaccount:"提現賬戶",
			selectpayaccount:"請選擇提現賬戶",
			paycount:"提現數額",
			tixiantip:"當日0點前提現，將於次日中午12:00 - 下午16:00處理",
			nowpay:"立即提現",
			paymenthistory:"提現記錄",
			date:"日期",
			id:"編號",
			type:"類型",
			unknown:"未知",
			money:"金額",
			search:"輸入關鍵字搜索",
			wcl:"未處理",
			clz:"處理中",
			yzf:"已支付",
			yth:"已退回",
			err:"異常",
			nodeaddress:"挖礦地址：",
			nodetip:"請不要使用含有中文名的挖礦賬戶或礦工名，以免給您帶來不必要的損失！",
			t_rex:"t-rex挖礦參數：",
			minername:"挖礦賬戶",
			minname:"礦工名",
			phoexminer:"PhoenxMiner挖礦參數：",
			nbminer:"Nbminer挖礦參數:",
			gminer:"Gminer挖礦參數:",
			teamredminer:"Teamredminer挖礦參數:",
			input:"請輸入六位驗證碼",
			codeerr:"驗證碼格式錯誤",
			inputeth:"請輸入ETH錢包地址",
			addresserr:"錢包格式錯誤",
			balanceinsuf:"餘額不足",
			googelcodetitle:"請在手機端打開谷歌驗證APP並輸入手機上顯示的六位驗證碼",
			googelcodetip:"請輸入驗證碼",
			confirmbtn:"確認",
			cancel:"取消",
			coderegerr:"驗證碼格式不正確",
			optinerr:"非法操作！",
			codeerr:"驗證碼錯誤",
			unknown:"未知錯誤",
			addsuccess:"添加成功",
			addexist:"該子賬戶已存在",
			loginfail:"登陸狀態失效，重新登陸",
			addtip:"子賬戶名以'st_'開頭",
			bindsuccess:"綁定成功",
			copysuccess:"複製成功",
			copytip:"請務必保存妥當",
			unbindgoogel:"尚未綁定谷歌驗證，請先綁定！",
			banaccount:"賬戶被封禁，請發起工單處理",
			cnypaytip:"最低100CNY起提現",
			usdtpaytip:"最低20USDT起提現",
			ethpaytip:"最低0.01ETH起提現",
			addpaysuccess:"提現成功",
			addpayfail:"創建訂單失敗",
			addpayonceday:"每天僅限提現一次",
			addpaybalanceinsuff:"餘額不足",
			unbindemaill:"未綁定電子郵件，禁止Alipay提款",
			down:"下載工具",
			minersetting:"挖礦設置參數",
			alipaykeyerr:"Alipay密鑰格式錯誤，僅支持數字、字母",
			accountmanager:"提現賬戶管理",
			addresserr:"地址錯誤",
			unknownerr:"未知錯誤",
			openlist:"開啟翻頁",
			closelist:"關閉翻頁",
			deletesuccess:"移除成功",
			deleteerror:"移除失敗",
			accounttype:"類型",
			accountaddress:"地址",
			accountname:"別名",
			accountoption:"操作",
			accountremove:"移除",
			hashcharts:"12小時算力圖",
			lastdayearn:"昨日收益",
			todayearn:"今日收益",
			lastdayearndisc:"昨日00:00:00-23:59:59(第一天挖礦收益會有一次收益在第二天發放)",
			todayearndisc:"今日00:00:00至今的收益",
			sfsyobserver:"是否啟用觀察者",
			observertip:"開啟後，可以免登入查詢礦工信息",
			copyobserver:"複製",
			openobserver:"打開",
			miner:"礦機",
			earning:"收益",
			
			hashrate:"算力",
			totalshare:"總份額",
			Valid:"有效份額",
			Stale:"延遲份額",
			Invalid:"無效份額",
			miners:"礦機",
			localhash:"本地算力",
			standby:"備用",
			temporarymaintenance:"臨時維護",
			okextip:"僅支持OKExChain(OKC)網絡",
			okexpayment:"ETH(OKC) 免手續費",
			okexdisc1:"ETH講使用OKC链【OKEx Chain】進行支付",
			bankcard:"银行卡提现 手续费:2%",
			cardNo:"銀行卡號",
			realname:"真實姓名",
			noresubmit:"請勿重複提交",
			unknown1:"未知",
			jine:"金額(約)：",
			wallet_address2:"錢包地址：",
			tixiantype:"提現類型：",
			tixiandilogtip:"請仔細確認錢包地址，提交後無法更改！",
			eachEarn:"每M收益",
		thresholdTip:"预更改阈值：",
		thresholdTip2:"提现阈值最小为0.05",
		walletTip:"预修改提现地址为：",
		walletTip2:"需Ethereum Classic主網地址，请确认錢包是否正确,因绑定错錢包而造成损失需自己承担后果。",
		walletTip3:"僅支持ETC主網，請確認錢包是否正確以免造成不必要的損失。",
		gohash:"点我查看",
		address:"提现地址",
		txhash:"交易记录",
		closure:"暫停提現，恢復時間等待通知"
		},
	observer:{
		wktobserver:"該子賬戶未開通觀察者"
	},
	noticelist:{
		check:"查看",
		personalnotice:"個人通知",
		systemnotice:"系統通知"
		
	},
	bata:{
		wallet:"錢包業務內測中,",
		yubibao:"幣生息業務內測中,",
		baoxian:"保險業務內測中,",
		wange:"網格交易業務內測中,",
		jiedai:"借貸务業務內測中,",
		bilicai:"雙幣理財業務內測中,",
		tip:"目前僅對擁有內測資格的用戶開放使用"
	}
}
export default hk;
